<template>
  <div class="g-wrapper g-vertical-block">
    <div class="c-document g-main-wrapper">
      <!-- filter -->
      <document-filter placeholder="请输入文案ID或者名称" @on-change="filterData" @on-search="searchFilterData">
        <el-button type="primary" @click="addDocument()">新增文案</el-button>
      </document-filter>
      <!-- table -->
      <div class="c-table-list">
        <Viewport v-model="tableHeight">
          <document-table
            :loading="loading"
            :data="tableList"
            :columns="tableCol"
            :height="tableHeight"
            @on-edit="addDocument"
            @on-del="delDocument"
            @on-refresh="getData"
          />
          <el-pagination
            class="c-table-page"
            background
            :current-page.sync="pageIndex"
            :page-sizes="[10, 20, 30, 40, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            @size-change="changePageSize"
            @current-change="changePageIndex"
          />
        </Viewport>
      </div>

      <!-- 弹出框 -->
      <document-set v-model="addDocModal" title="文案" :info="info" :edit="isEditState" :loading="loading" @on-save="saveDocument" />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { Message, MessageBox } from 'element-ui'
import { setLocal, getLocal } from '@/common/js/api'
import { isArray, isEmpty, trim } from '@/common/js/utils'
import { listPlanDocument, getPlanDocument, deletePlanDocument, addPlanDocument, savePlanDocument } from '@/api/manage.model'
import DocumentFilter from './components/document-filter.vue'
import DocumentTable from './components/document-table.vue'
import DocumentSet from './components/document-set.vue'
import columns from '../data/document_column'

const tableHeight = ref(330)
const addDocModal = ref(false)
const isEditState = ref(false)
const info = ref({})

// Mixin Logic
const loading = ref(false)
const pageIndex = ref(1)
const pageSize = ref(10)
const total = ref(0)
const tableList = ref([])
const tableCol = ref(columns)
const params = ref({})

const getData = (filter) => {
  let queryParams = {
    page_id: pageIndex.value,
    page_size: pageSize.value
  }
  if (filter) queryParams = Object.assign(queryParams, filter)
  else queryParams = Object.assign(params.value, queryParams)

  params.value = JSON.parse(JSON.stringify(queryParams))

  loading.value = true
  listPlanDocument(queryParams)
    .then((data) => {
      loading.value = false
      if (!data) return
      const { list, page_info } = data
      if (isArray(list) && page_info) {
        const { total_number } = page_info
        total.value = total_number || 0
        tableList.value = list.map((ret) => ret)
      }
    })
    .catch((err) => {
      loading.value = false
      Message.error({
        duration: 5000,
        message: err
      })
    })
}

const changePageIndex = (index) => {
  pageIndex.value = index
  getData()
}

const changePageSize = (size) => {
  setLocal('DOCUMENT_PAGESIZE', size)
  pageSize.value = size
  if (pageIndex.value !== 1) {
    pageIndex.value = 1
  }
  getData()
}

const searchFilterData = (filterParams) => {
  pageIndex.value = 1
  getData(filterParams)
}

const filterData = (filterParams) => {
  pageIndex.value = 1
  getData(filterParams)
}

const delDocument = (row) => {
  const { docId } = row
  deletePlanDocument({ docId }).then((data) => {
    if (data) {
      getData()
    }
  })
}

const addDocument = (editParams) => {
  isEditState.value = !!editParams
  if (editParams) {
    const { docId } = editParams
    loading.value = true
    getPlanDocument({ docId }).then((data) => {
      loading.value = false
      if (data) {
        const { docId, gameIds, docContent } = data
        let games, type
        if (isEmpty(gameIds)) {
          games = []
          type = 'all'
        } else {
          games = gameIds.includes(',') ? gameIds.split(',').map((ret) => parseInt(ret)) : [parseInt(gameIds)]
          type = 'game'
        }
        info.value = { docId, games, docContent, type, group: '' }
        addDocModal.value = true
      }
    })
  } else {
    info.value = { docContent: '', type: 'game', group: '', games: [] }
    addDocModal.value = true
  }
}

const saveDocument = (saveParams) => {
  let { docId, games, docContent } = saveParams
  const gameIds = games.join(',')
  docContent = trim(docContent)
  if (docId) {
    loading.value = true
    savePlanDocument({ docId, gameIds, docContent }).then((data) => {
      loading.value = false
      if (data) {
        getData()
        addDocModal.value = false
      }
    })
  } else {
    loading.value = true
    addPlanDocument({ gameIds, docContent }).then((data) => {
      loading.value = false
      if (data) {
        const { successTotal, failTotal } = data
        if (typeof successTotal === 'number' || typeof failTotal === 'number') {
          MessageBox.alert(`成功${data.successTotal}条，失败${data.failTotal}条`, '添加结果', {
            confirmButtonText: '知道了'
          })
          getData()
          addDocModal.value = false
        } else {
          Message.error('添加文案失败！')
        }
      }
    })
  }
}

onMounted(() => {
  const localPageSize = parseInt(getLocal('DOCUMENT_PAGESIZE'))
  if (localPageSize) pageSize.value = localPageSize
  else pageSize.value = 20

  // proloadData()
})
</script>

<style lang="scss" scoped>
.c-document {
  width: 100%;
  height: 100%;
  padding: 8px 8px 0;
}

.c-table-page {
  padding: 5px 0;
  text-align: right;
}
</style>
